<template>
  <div class="border-normal" @click="toDetail" :class="{'not-allowed':!hasAuth}">
    <template v-if="numMiddle">
      <div class="card-icon">
        <svg-icon :icon-name="iconName" size="32" :iconColor="iconColor"></svg-icon>
      </div>
      <div class="item-number">{{ itemNumber }}</div>
      <div class="item-name">{{ itemName }}</div>
    </template>
    <template v-else>
      <div class="flex item-center">
        <div class="card-icon mr-20">
        <svg-icon :icon-name="iconName" size="32" :iconColor="iconColor"></svg-icon>
      </div>
      <div class="item-name">{{ itemName }}</div>
      </div>
      <div class="item-number">{{ itemNumber }}</div>
    </template>
  </div>
</template>
<script>
import SvgIcon from '@/components/svgIcon/index'
export default {
  name: 'CardItem',
  components: { SvgIcon },
  props: {
      iconName: { type: String, default: '' },
      href: { type: String, default: '' },
      status: { type: String, default: '' },
      itemName:{ type: String, default: '' },
      itemNumber:{ type: Number, default: null },
      numMiddle:{ type: Boolean, default: true },
      hasAuth:{ type: Boolean, default: false },
  },
  computed: {
    iconColor(){
      return this.hasAuth?'#1e49e2':'#8690a1'
    }
  },
  methods:{
    toDetail(){
      this.$emit('toFilterList',this.href,this.status)
    }
  }
}
</script>

<style scoped>
.card-icon{
  width: 64px;
  height: 64px;
  line-height:64px;
  text-align: center;
  border-radius: 10px;
  background: #f3f6ff;
  cursor: pointer;
}
.border-normal:hover{
  border:1px solid #1e49e2;
}
.item-number{
  font-size: 30px;
  font-weight: bold;
}
.item-name{
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}
.not-allowed{
  cursor: not-allowed !important;
}

</style>

